'use strict';

const kdContextError = require('./kd-context');

/**
 * Authentication Error
 *
 * This error denotes an Authentication Error, usually thrown if
 * credentials cannot be verified or are invalid.
 *
 * If `context` is provided, it should contain information relevant to
 * the failed authentication attempt (credentials, attempted operation)
 *
 * @param {string} message - Error message
 * @param {Object} detail - Error detail message
 * @param {Object} context - Authentication context data
 */
class AuthenticationError extends kdContextError {
    constructor(message, detail, context) {
        super(message, detail, context);
        this.name = 'AuthenticationError';
        this.status = 401;
    }
}

module.exports = AuthenticationError;



/** WEBPACK FOOTER **
 ** ./src/common/error/authentication.js
 **/